import { makeStyles } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import {DownloadOutlined} from '@ant-design/icons'
import { Popover } from 'antd'

const useStyles = makeStyles(theme => ({
    file_link: {
        color: '#000000',
        textDecoration: 'underline',

        '&:active': {
            textDecoration: 'underline',
        },
        '&:focus': {
            textDecoration: 'underline',
        }
    }
}))

/**
 * Renders links to different files (mostly, csv) 
 * And provides a uniform view 
 */
const FileLink = ({file_url, show_file_label=false}) => {
    const classes = useStyles()

    const extractFileName = () => {
        // split file link by '/' and find the entry that ends in .csv
        if(show_file_label){
            let split_name = file_url.split('/')
            split_name = split_name.filter(f => f !== "")

            // check for an entry that contains .csv 
            let entry = split_name.find(f => f.toString().indexOf('.csv') !== -1)
            if(entry){
                const filename = entry.split('?').shift()
                return filename
            }
            entry = split_name.find(f => f.toString().indexOf('.log') !== -1)
            if(entry){
                const filename = entry.split('?').shift()
                return filename
            }

        }

        return "Download"
        
    }

    return (
        <>
            {
                file_url ? (
                    <>
                        <a download href={file_url} className={classes.file_link}>
                            {/* {extractFileName()} */}
                            {!show_file_label ? <Popover content={extractFileName()}>
                                <DownloadOutlined style={{fontSize: '26px'}} />
                            </Popover> : extractFileName()}
                        </a> <br/>
                    </>
                    
                ): <span>-</span>
            }
        </>
    )
}

FileLink.propTypes = {
    file_url: PropTypes.string
}

export default FileLink